export default "__VITE_ASSET__DP08Ga$H__"